import React, { RefObject } from 'react';
import { SurfaceNodeType, SurfaceNodeUnion } from 'graphql/types';
import useDraggingNodeId from 'components/canvas/hooks/use-dragging-node-id';
import { color } from 'styles/settings';

interface UseDragShadowProps {
  ref?: RefObject<any>;
  node?: SurfaceNodeUnion;
}

export default function useDragShadow(props: UseDragShadowProps) {
  const [isDragging, setIsDragging] = React.useState(false);
  const [draggingNodeId] = useDraggingNodeId();

  React.useEffect(() => {
    if (!props.ref?.current || !props.node?.id) {
      return;
    }

    const isThisNodeDragged = draggingNodeId === props.node.id;

    if (isThisNodeDragged) {
      setIsDragging(true);
      props.ref.current.setAttrs({
        shadowOffset: { x: 10, y: 10 },
        shadowBlur: 10,
        shadowOpacity: 0.15,
        shadowColor: '#000000',
        ...(() => {
          const additionalAttributes = {};
          if (props.node.type === SurfaceNodeType.Text) {
            additionalAttributes['fill'] = color.ui.canvasBackground;
          }

          return additionalAttributes;
        })(),
      });
    } else if (isDragging && !isThisNodeDragged) {
      setIsDragging(false);
      props.ref.current.setAttrs({
        shadowOpacity: 0,
        ...(() => {
          const additionalAttributes = {};
          if (props.node.type === SurfaceNodeType.Text) {
            additionalAttributes['fill'] = 'transparent';
          }

          return additionalAttributes;
        })(),
      });
    }
  }, [draggingNodeId, props.node?.type, props.node?.id, isDragging, props.ref]);

  return [isDragging];
}
